import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

export function isNotFoundError(error?: AxiosError) {
  return error?.response?.status === 404;
}

export function isBadRequestError(error?: AxiosError) {
  return error?.response?.status === 400;
}

export function isForbiddenRequestError(error?: AxiosError) {
  return error?.response?.status === 403;
}

// FIXME: Use this after verifying all apis that hco uses.
// const getData = <T>(res: AxiosResponse<T>): T => snakeToCamel(res.data);
const getData = <T>(res: AxiosResponse<T>): T => res.data;

export const getAxiosInstanceMethods = (axiosInstance: AxiosInstance) => {
  return {
    get: <T = {}>(url: string) => axiosInstance.get<T>(url).then(getData),
    post: <T = {}>(url: string, data: any) => axiosInstance.post<T>(url, data).then(getData),
    put: <T = {}>(url: string, data: any) => axiosInstance.put<T>(url, data).then(getData),
    delete: <T = {}>(url: string) => axiosInstance.delete<T>(url).then(getData)
  };
};
